import Vue from 'vue'
import Router from 'vue-router'
import login from '../components/login/login.vue'
import main from '../components/main.vue'
import home from '@/router/home/home.js' 
import jm from '@/router/jm/jm.js' 
import alliance from '@/router/alliance/alliance.js'
import oper from '@/router/oper/oper.js'
Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			redirect: '/login'
		},
		{
			path: '/login',
			name: 'login',
			component: login
		},
		{
			path: '/main',
			name: 'main',
			component: main,
			children: [
				...home,
				 ...jm,
				 ...alliance,
				 ...oper
			]
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js